import { useEffect, useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { useAuth } from "../../providers/authprovider";

function getRequestErrorMessage(result) {
  if (result.error) return result.error;

  return `Nie udało się zapisać danych. Status odpowiedzi: ${result.status}`;
}

export default function OfferPriceGroupModal({ show, onHide, onCreated }) {
  const { offerPrices } = useAuth();
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) {
      setGroupName("");
      setError("");
      setSaving(false);
    }
  }, [show]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSaving(true);

    const result = await offerPrices.createGroup(groupName.trim());
    if (!result.success) {
      setSaving(false);
      setError(getRequestErrorMessage(result));
      return;
    }

    onCreated(result.content);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Utwórz grupę</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group controlId="offerPriceGroupName">
            <Form.Label>Nazwa grupy</Form.Label>
            <Form.Control
              type="text"
              value={groupName}
              onChange={(event) => setGroupName(event.target.value)}
              disabled={saving}
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={saving}>
            Anuluj
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={saving || !groupName.trim()}
          >
            {saving ? "Zapisywanie..." : "Dodaj"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
